import CallbackPopup from '~/src/packages/bp42/containers/CallbackPopup';

export default CallbackPopup;
